import { api } from '@/lib/api-client'
import type { AdminUser, MessageResponse, PageResponse, PeopleFilters } from '@/types/api'

export function fetchUsers(filters: PeopleFilters): Promise<PageResponse<AdminUser>> {
  return api.get<PageResponse<AdminUser>>('/api/admin/users', { query: { ...filters } })
}

export function fetchUser(id: number): Promise<AdminUser> {
  return api.get<AdminUser>(`/api/admin/users/${id}`)
}

export function suspendUser(id: number): Promise<MessageResponse> {
  return api.patch<MessageResponse>(`/api/admin/users/${id}/suspend`)
}

export function activateUser(id: number): Promise<MessageResponse> {
  return api.patch<MessageResponse>(`/api/admin/users/${id}/activate`)
}

export function verifyUserPhone(id: number): Promise<MessageResponse> {
  return api.patch<MessageResponse>(`/api/admin/users/${id}/verify-phone`)
}
